/**
 * File Name          : app-command-packet.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { Uint16Bytes } from "../../byte-helpers";
import { Packet, PACKET_TYPE } from "./packet.model";
// import { PACKET_TYPE, Packet } from "../packet.model";

export class AppCommandPacket extends Packet {
    mPacketSubType?: number

    constructor() {
        super()
        this.mPacketType = PACKET_TYPE.APP_COMMAND
    }

    payloadByteCalculator: ((bytes: Uint8Array)=>Uint8Array)|null = null;

    override calcBytes() {
        if(this.mPacketSubType == undefined) return false;
        if(this.mPayloadLength == undefined) return false;

        const payloadLen = 2 + this.mPayloadLength;
        let mBytes = new Uint8Array(payloadLen * 4).fill(0x00);

        mBytes[0] = 0xCC;
        mBytes[1] = payloadLen - 2;

        const packetNumberBytes = Uint16Bytes(this.mPacketNumber!);
        mBytes.set(packetNumberBytes, 2);

        mBytes[4] = this.mPacketType!;
        mBytes[5] = this.mPacketSubType!;

        if(!this.payloadByteCalculator) {
            console.warn("no payload byte caclulator set, unable to calc bytes");
            return false
        }
        mBytes = this.payloadByteCalculator(mBytes) as any


        const crc = this.calcCRC16(mBytes, 0x00);
        const crcBytes = Uint16Bytes(crc);
        mBytes.set(crcBytes, 6);

        this.mBytes = mBytes
        return true;
    }
}